export default __webpack_public_path__ + "static/media/image-board-study-now-n-m@2x.9973d4b6.webp";